<template>
    <div
        class="site-admin-page weeduc-admin-page global-site-weeduc adminWeeducSite text-start p-0"
        data-aos="fade-left"
        data-aos-duration="1500"
    >
        <header class="weeduc-admin-page__header">
            <div class="weeduc-admin-page__header-lead">
                <TitlePage
                    title="Site"
                    subtitle="Configure identidade, layout, domínio, integrações e o portal do aluno."
                    :hasMargin="false"
                />
            </div>
        </header>

        <div class="weeduc-admin-page__shell">
            <div class="weeduc-admin-page__panel weeduc-admin-site-panel-wrap">
                <nav class="weeduc-admin-site-tabs" aria-label="Seções do site">
                    <button
                        v-for="tab in siteTabs"
                        :key="tab.id"
                        type="button"
                        class="weeduc-admin-site-tab"
                        :class="{ 'weeduc-admin-site-tab--active': activeTab === tab.id }"
                        @click="setActiveTab(tab.id)"
                    >
                        {{ tab.label }}
                    </button>
                </nav>

                <div class="weeduc-admin-site-panels">
                    <section
                        v-show="isActiveTab(1)"
                        class="section config-form primary weeduc-admin-site-section"
                        :class="{ active: isActiveTab(1) }"
                    >
                        <Config />
                    </section>

                    <section
                        v-show="isActiveTab(2)"
                        class="section config-form primary weeduc-admin-site-section"
                        :class="{ active: isActiveTab(2) }"
                    >
                        <Content />
                    </section>

                    <section
                        v-show="isActiveTab(3)"
                        class="section config-form primary weeduc-admin-site-section"
                        :class="{ active: isActiveTab(3) }"
                    >
                        <Domain />
                    </section>

                    <section
                        v-show="isActiveTab(4)"
                        class="section config-form primary weeduc-admin-site-section"
                        :class="{ active: isActiveTab(4) }"
                    >
                        <Integration />
                    </section>

                    <section
                        v-show="isActiveTab(5)"
                        class="section config-form primary weeduc-admin-site-section"
                        :class="{ active: isActiveTab(5) }"
                    >
                        <Advanced />
                    </section>

                    <section
                        v-show="isActiveTab(6)"
                        class="section config-form primary weeduc-admin-site-section"
                        :class="{ active: isActiveTab(6) }"
                    >
                        <PortalStudent />
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Config from '@/components/Admin/Site/config'
    import Content from '@/components/Admin/Site/content'
    import Social from '@/components/Admin/Site/social'
    import Testimonials from '@/components/Admin/Site/testimonials'
    import Domain from '@/components/Admin/Site/domain'
    import Layout from '@/components/Admin/Site/layout'
    import Integration from '@/components/Admin/Site/integrations'
    import Advanced from '@/components/Admin/Site/advanced'
    import PortalStudent from '@/components/Admin/Site/portalStudent'
    import TitlePage from '@/components/Weflix/titlePage.vue'

    export default {
        data() {
            return {
                activeTab: 1,
                hassaved: false,
                openmodalmodule: false,
                siteTabs: [
                    { id: 1, label: 'Básico' },
                    { id: 2, label: 'Layout' },
                    { id: 6, label: 'Portal do Aluno' },
                    { id: 3, label: 'Domínio' },
                    { id: 4, label: 'Integrações' },
                    { id: 5, label: 'Avançado' },
                ],
            }
        },
        props: {
    
        },
        components: {
            Config,
            Content,
            Social,
            Testimonials,
            Domain,
            Layout,
            Integration,
            Advanced,
            PortalStudent,
            TitlePage,
        },
        methods: {
            updatevalue(novoValor) {
                this.hassaved = novoValor;
            },
    
            setActiveTab(tabNumber) {
                this.activeTab = tabNumber;
            },
            isActiveTab(tabNumber) {
                return this.activeTab === tabNumber;
            },
            openmodal() {
                this.openmodalmodule = !this.openmodalmodule;
            },
            atualizarValorNoFilho(novoValor) {
                this.openmodalmodule = novoValor;
            }
        },
        created() {
    
        }
    }
</script>

<style scoped>
    @import url('@/css/weeduc/admin/dashboard-weflix-shell.css');

    .weeduc-admin-site-panel-wrap {
        padding-top: 1.1rem;
    }

    .weeduc-admin-site-tabs {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 0.4rem;
        margin: 0 0 1.2rem;
        padding-bottom: 1.05rem;
        border-bottom: 1px solid #f0f2f5;
    }

    .weeduc-admin-site-tab {
        font-family: 'Inter', system-ui, sans-serif;
        font-size: 13px;
        font-weight: 500;
        line-height: 1.3;
        color: #5c6370;
        background: #f4f5f8;
        border: 1px solid #e8eaf0;
        border-radius: 10px;
        padding: 0.45rem 0.95rem;
        cursor: pointer;
        transition:
            background 0.2s ease,
            border-color 0.2s ease,
            color 0.2s ease,
            box-shadow 0.2s ease;
    }

    .weeduc-admin-site-tab:hover {
        color: #250891;
        border-color: rgba(37, 8, 145, 0.28);
        background: rgba(37, 8, 145, 0.06);
    }

    .weeduc-admin-site-tab--active {
        color: #fff !important;
        background: linear-gradient(135deg, #3d2bb3 0%, #250891 100%) !important;
        border-color: transparent !important;
        box-shadow: 0 2px 10px rgba(37, 8, 145, 0.28);
    }

    .weeduc-admin-site-panels {
        min-height: 200px;
    }

    .weeduc-admin-site-section {
        display: block;
    }

    @media (max-width: 500px) {
        .redes-sociais-mobile {
            min-width: fit-content !important;
        }

        .weeduc-admin-site-tabs {
            gap: 0.35rem;
        }

        .weeduc-admin-site-tab {
            font-size: 12.5px;
            padding: 0.4rem 0.75rem;
        }
    }

    .dashboard.dark .weeduc-admin-site-tabs {
        border-bottom-color: #353945;
    }

    .dashboard.dark .weeduc-admin-site-tab {
        color: #c5cad6;
        background: #2a2d36;
        border-color: #3d414d;
    }

    .dashboard.dark .weeduc-admin-site-tab:hover {
        color: #e8eaf0;
        border-color: #6d5acd;
        background: rgba(109, 90, 205, 0.15);
    }

    .dashboard.dark .weeduc-admin-site-tab--active {
        background: linear-gradient(135deg, #4a3bbd 0%, #392497 100%) !important;
        border-color: transparent !important;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.35);
    }
</style>